<template>
  <div class="mt-16">
    <UnitSold class="mb-8" :nbUnit="product.nbUnitSold" />
    <div class="flex justify-between align-top">
      <TitleLabel :product-titles="product.titles" />
      <div
        v-if="!hideFavoritesButton"
        class="text-static-default-hi mb-8 flex flex-row justify-end"
      >
        <FavoritesToggle
          v-if="!hideFavoritesButton"
          class="bg-static-default-low rounded-full"
          :grade-id="selectedOffer?.grade.value"
          is-rounded
          :offer-type
          :price="selectedOffer?.price"
          :product-uuid="product.productId"
          :tracking-info="favoritesTrackingInfo"
          zone="details"
        />
      </div>
    </div>

    <RatingInfo v-if="rating" anchor-id="reviews" class="mb-8" :rating />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type { Rating } from '@backmarket/http-api/src/api-specs-reviews/types/rating'

import FavoritesToggle from '~/scopes/dashboard/favorites/toggle/FavoritesToggle.vue'
import { fromProductTrackingModel } from '~/scopes/dashboard/favorites/utils/FavoriteTrackingModel'
import UnitSold from '~/scopes/product-core/components/presentationals/UnitSold/UnitSold.vue'
import { useProductTracking } from '~/scopes/product-core/composables/useFetch/useFetchProductTracking/composables/useProductTracking/useProductTracking'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'
import RatingInfo from '~/scopes/reviews/reviews-display/components/Rating/Rating.vue'

import TitleLabel from './TitleLabel.vue'

const props = withDefaults(
  defineProps<{
    selectedOffer?: GetPickersResponse['selectedOffer'] | null
    product: GetProductResponse
    rating?: Rating | null
    tracking: ReturnType<typeof useProductTracking>
    hideFavoritesButton?: boolean
  }>(),
  {
    selectedOffer: null,
    rating: null,
    hideFavoritesButton: false,
  },
)

const { offerType } = useUrlParams()

const favoritesTrackingInfo = computed(() => {
  return fromProductTrackingModel(props.tracking.product.value)
})
</script>
